import { IconWarningCircle16, UIText2, UIText3 } from '@cian/ui-kit';

import { FC } from 'react';

import { useListingLayoutIsShortSelector } from 'shared/store/clientSide/slices/listingLayout';

import styles from './SlideOverlayContent.css';

type SlideOverlayContentProps = {
  children: string;
};

export const SlideOverlayContent: FC<SlideOverlayContentProps> = props => {
  const { children } = props;

  const UIText = useListingLayoutIsShortSelector() ? UIText3 : UIText2;

  return (
    <div className={styles['container']}>
      <IconWarningCircle16 color="white_100" />
      <UIText color="white_100" fontWeight="700" textAlign="center">
        {children}
      </UIText>
    </div>
  );
};
